import { Button } from "@/lib/components/Button/Button";
import { Input } from "@/lib/components/Input";
import Toast from "@/lib/components/Toast";
import { CreateTeamDto } from "@repo/api/team";
import { useState } from "react";

type CreateTeamFormProps = {
  onSubmit: (data: CreateTeamDto) => void;
  isPending: boolean;
};

export default function CreateTeamForm({
  onSubmit,
  isPending,
}: CreateTeamFormProps) {
  const [name, setName] = useState("");

  return (
    <div className="w-full overflow-y-auto rounded-xl border bg-background px-10 py-8 shadow-lg sm:w-100">
      <div className="flex flex-col items-center">
        <h1 className="text-lg font-bold">Create a team</h1>
        <h2 className="text-sm text-text-secondary">
          You can later invite others to join!
        </h2>
        <form
          className="mt-6 w-full"
          onSubmit={(e) => {
            e.preventDefault();

            if (!name) {
              Toast.info("Please enter a team name");
              return;
            }

            onSubmit({ name });
          }}
        >
          <Input
            value={name}
            placeholder="Team name"
            id="name"
            onChange={(e) => setName(e.target.value)}
            className="mb-4"
          />
          <Button className="w-full" disabled={isPending} isLoading={isPending}>
            Create team
          </Button>
          <div className="h-3"></div>
        </form>
      </div>
    </div>
  );
}
